export default "__VITE_ASSET__PIXq7JIP__"